/**
 * @generated SignedSource<<fda111f34bb1ebb49858897f8ecd7269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
export type StopJobRunInput = {
  jobRunId: any;
};
export type StopJobRunMutation$variables = {
  input: StopJobRunInput;
};
export type StopJobRunMutation$data = {
  readonly stopJobRun: {
    readonly jobRun: {
      readonly id: any;
      readonly status: GraphQLJobRunStatus;
    };
    readonly success: boolean;
  };
};
export type StopJobRunMutation = {
  response: StopJobRunMutation$data;
  variables: StopJobRunMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StopJobRunPayload",
    "kind": "LinkedField",
    "name": "stopJobRun",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJobRun",
        "kind": "LinkedField",
        "name": "jobRun",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StopJobRunMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StopJobRunMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8dc989d1466818c987e80441e5589d5c",
    "id": null,
    "metadata": {},
    "name": "StopJobRunMutation",
    "operationKind": "mutation",
    "text": "mutation StopJobRunMutation(\n  $input: StopJobRunInput!\n) {\n  stopJobRun(input: $input) {\n    success\n    jobRun {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2588b03bf5a4603fcb5d48aab9722621";

export default node;
